import CreateCollaborativeView from "@features/tools/view/collaborative-view/create-collaborative-view";

const CreateCollaborative = () => {
  return <CreateCollaborativeView />;
};

export default CreateCollaborative;
